import { call, put, takeEvery, takeLatest, all } from 'redux-saga/effects'

import { fetchFailed, setDesigns, setCatalogues, addDesign, updateDesign, showAlert, loadDesign } from '../actions';
import { request } from '../modules/client';
import config from "../config";

import sampleDesigns from '../design';

function* onFetchTemplates() {
    yield takeLatest('FETCH_DESIGNS', function* fetchDesigns() {
        try {
            // const designs = yield call(request, `${config["strapi-server"]}/templates`);

            yield put(setDesigns(sampleDesigns));
            yield put(loadDesign({designId:'design_welcome'}));
        } catch (e) {
            yield put(fetchFailed(e));
            return;
        }
    });
}

function* onFetchCatalogues() {
    yield takeLatest('FETCH_CATALOGUES', function* fetchDesigns() {
        try {
            const designs = yield call(request, `${config["strapi-server"]}/catalogues`);
            yield put(setCatalogues(designs));
        } catch (e) {
            yield put(fetchFailed(e));
            return;
        }
    });
}

function* onSaveDesign() {
    yield takeLatest('SAVE_DESIGN', function* saveDesign(action) {
        const {payload} = action;
        console.log('in save action', payload);

        if (payload.id === undefined) {
            const design = yield call(request, `${config["strapi-server"]}/templates`, {
                method: 'POST',
                payload: {template: payload}
            });
            yield put(addDesign(design));
        } else {
            const design = yield call(request, `${config["strapi-server"]}/templates/${payload.id}`, {
                method: 'PUT',
                payload: {template: {
                    header: payload.header,
                    footer: payload.footer,
                    body: payload.body
                }}
            });
            yield put(updateDesign(design));
        }
        yield put(showAlert(true));
    });
}


export default function* rootSaga() {
    yield all([
        onFetchTemplates(),
        // onFetchCatalogues(),
        // onSaveDesign()
    ])
}